"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const async_mutex_1 = require("async-mutex");
const Sleep_1 = require("../concurrency/Sleep");
class TokenBucketRefillerImpl {
    constructor(tokenRefillMutex, tokenRefillStrategy, tokenBucket) {
        this.tokenRefillMutex = tokenRefillMutex;
        this.tokenRefillStrategy = tokenRefillStrategy;
        this.tokenBucket = tokenBucket;
    }
    ;
    reportSuccess() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.tokenRefillStrategy.reportSuccess();
        });
    }
    reportFailure() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.tokenRefillStrategy.reportFailure();
        });
    }
    scheduleNextRefill() {
        return __awaiter(this, void 0, void 0, function* () {
            yield (0, async_mutex_1.tryAcquire)(this.tokenRefillMutex)
                .runExclusive(() => __awaiter(this, void 0, void 0, function* () {
                let isBucketFull = this.tokenBucket.isBucketFull();
                while (!isBucketFull) {
                    const delay = this.tokenRefillStrategy.getNextTokenRefillDelay();
                    yield (0, Sleep_1.sleep)(delay);
                    this.tokenBucket.addToken();
                    isBucketFull = this.tokenBucket.isBucketFull();
                }
            }))
                .catch(error => {
                if (error !== async_mutex_1.E_ALREADY_LOCKED) {
                    throw error;
                }
            });
        });
    }
}
exports.default = TokenBucketRefillerImpl;
